globalThis.WorldList = class WorldList {
  constructor(options) {
    this.worlds = options.worlds || [];
    this.abort = new AbortController();
    this.items = [];
    this.page_size = options.page_size || 3;
    this.div = document.createElement("div");
    this.div.classList.add("world-list");
    this.div.innerHTML = `
      <h2>
        <span>${options.title || "World List"}</span>
        <div class="control"></div>
      </h2>
      <div class="body"></div>
    `;
    this.control = this.div.querySelector(".control");
    this.body = this.div.querySelector(".body");
    for (const { title, onclick } of options.control || []) {
      const button = document.createElement("button");
      button.innerText = title;
      button.addEventListener("click", onclick, this.abort);
      this.control.append(button);
    }
    this.pagination = new Pagination();
    this.pagination.div.addEventListener(
      "active",
      this.updatePage.bind(this),
      this.abort,
    );
    this.div.append(this.pagination.div);
    this.updatePage();
  }

  remove() {
    this.abort.abort();
    this.pagination.remove();
    this.removeCards();
    this.div.remove();
  }

  setWorlds(worlds) {
    this.worlds = worlds;
    this.updatePage();
  }

  updatePage() {
    const pages = Math.ceil(this.worlds.length / this.page_size);
    this.pagination.setPages(pages);
    this.removeCards();
    this.createCards();
  }

  removeCards() {
    for (const item of this.items) item.remove();
    this.items = [];
  }

  createCards() {
    const start = this.pagination.active * this.page_size;
    const end = start + this.page_size;
    const list = this.worlds.slice(start, end);
    for (const world of list) {
      const item = new WorldListItem(world);
      this.items.push(item);
      this.body.append(item.div);
    }
  }
};
